import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from '@mui/material/Tooltip';
import { ThemeProvider } from '@mui/material/styles';
import createTheme from '@mui/material/styles/createTheme';
import QuestionIcon from '@assets/icons/question-icon.svg';
import DniIcon from '@assets/icons/dni.svg';
import DniAnimation from '@assets/icons/DNI.gif';
const DniTooltip = (props) => {
    const { className = '', showAnimation = false } = props;
    const CustomDniTooltipTheme = createTheme({
        components: {
            MuiTooltip: {
                styleOverrides: {
                    arrow: {
                        fontSize: 30
                    },
                    tooltipPlacementRight: {
                        backgroundColor: '#E6E9ED',
                        padding: "16px",
                        width: '360px',
                        borderRadius: '24px',
                        top: '-30px',
                        left: '5px',
                        span: {
                            color: '#E6E9ED',
                            top: '20px !important'
                        },
                    },
                }
            }
        }
    });
    return (_jsx(ThemeProvider, { theme: CustomDniTooltipTheme, children: _jsx(Tooltip, { className: `register-step-one_tooltip ${className ?? ''}`, title: _jsx("img", { src: showAnimation ? DniAnimation : DniIcon, className: "dni-icon", alt: "dni-icon" }), placement: "right-start", arrow: true, sx: {
                window: '500px',
                backgroundColor: 'red'
            }, children: _jsx("img", { src: QuestionIcon, alt: "question-icon" }) }) }));
};
export default DniTooltip;
